import { AssetType } from "@pulse/pulse-rpcs/lib/file-service/assetType";
import { AssetObjectType } from "./types";

export const assetObjects: Record<AssetType.AssetType, AssetObjectType> = {
  [AssetType.AssetType.RICH_TEXT_DOCUMENTS]: {
    allowedFileTypes: [
      {
        name: "csv",
        fileSize: {
          minSize: 10,
          maxSize: 1000000,
        },
      },
      {
        name: "xlsx",
        fileSize: {
          minSize: 100,
          maxSize: 500000,
        },
      },
      {
        name: "pdf",
        fileSize: {
          minSize: 1,
          maxSize: 1000000,
        },
      },
      {
        name: "jpg",
        fileSize: {
          minSize: 1,
          maxSize: 10000000,
        },
      },
      {
        name: "jpeg",
        fileSize: {
          minSize: 1,
          maxSize: 10000000,
        },
      },
      {
        name: "png",
        fileSize: {
          minSize: 1,
          maxSize: 10000000,
        },
      },
      {
        name: "svg",
        fileSize: {
          minSize: 1,
          maxSize: 10000000,
        },
      },
      {
        name: "gif",
        fileSize: {
          minSize: 1,
          maxSize: 10000000,
        },
      },
      {
        name: "webp",
        fileSize: {
          minSize: 1,
          maxSize: 10000000,
        },
      },
    ],
  },
};
